/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import { Box } from '../components/Layout';
import colors from '../utils/colors';

const style = css`
  text-align: center;
  padding-bottom: 10%;
`;

const tekijaStyle = css`
  h3 {
    margin-top: 0.1em;
    margin-bottom: 0.1em;
  }
  margin-top: 2em;
`;

const imgStyle = css`
  border-radius: 5px;
  margin-bottom: 1em;
`;

const outerImgWrapper = css`
  width: 8em;
  margin-left: auto;
  margin-right: auto;
`;

const Tekijat = ({ data }) => {
  const { elena, mika, kaisa, hanna, erja } = data;
  return (
    <Box>
      <Box
        className={style}
        width={[1, 1, 1 / 2]}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
        color={colors.secondary}
      >
        <h1>Tekijät</h1>

        <div className={tekijaStyle}>
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Elena Vuoksiola"
            sizes={elena.childImageSharp.sizes}
          />
          <h3>Elena Vuoksiola</h3>
          <p>Käsikirjoittaja, ohjaaja</p>
        </div>
        <div className={tekijaStyle}>
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Hanna Poikela"
            sizes={hanna.childImageSharp.sizes}
          />
          <h3>Hanna Poikela</h3>
          <p>Koreografi, tuottaja</p>
        </div>
        <div className={tekijaStyle}>
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Erja Mesimäki"
            sizes={erja.childImageSharp.sizes}
          />
          <h3>Erja Mesimäki</h3>
          <p>Säveltäjä</p>
        </div>
        <div className={tekijaStyle}>
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Kaisa Alatalo"
            sizes={kaisa.childImageSharp.sizes}
          />
          <h3>Kaisa Alatalo</h3>
          <p>Suunnittelija, järjestäjä harjoituskaudella</p>
        </div>
        <div className={tekijaStyle}>
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Mika Ryynänen"
            sizes={mika.childImageSharp.sizes}
          />
          <h3>Mika Ryynänen</h3>
          <p>Valosuunnittelija</p>
        </div>
      </Box>
    </Box>
  );
};

export const query = graphql`
  query TekijatQuery {
    elena: file(relativePath: { eq: "elenavuoksiola.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    mika: file(relativePath: { eq: "mikaryynanen.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    kaisa: file(relativePath: { eq: "kaisaalatalo.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    hanna: file(relativePath: { eq: "hannapoikela.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    erja: file(relativePath: { eq: "erjamesimaki.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;

export default Tekijat;



// WEBPACK FOOTER //
// ./src/pages/tekijat.js